import React from 'react';

import type { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface IProps {
  onClose?: () => void;
}

const ClickDialogCloseBtn: React.FC<IProps> = React.memo(({ onClose }) => {
  return (
    <div>
      <FontAwesomeIcon
        className="cursor-pointer text-xl text-gray-500"
        icon={faTimes as IconLookup}
        onClick={onClose}
      />
    </div>
  );
});

ClickDialogCloseBtn.displayName = 'ClickDialogCloseBtn';

export default ClickDialogCloseBtn;
